module.exports = __webpack_public_path__ + "static/media/local-k-dark.86df8796.png";